module.exports = __webpack_public_path__ + "media/images/wedding/cover-mobile@2x-78ed7a57c0dfb604d838685736c69eae.jpg";